import { UseFormHandleSubmit } from "react-hook-form";
import { useStoreState } from "atoms/storeAtom";
import { useAtom } from "jotai";

import { Button, EButtonVariant } from "components/Button/Button";

import { setInfoModalAtom } from "../../../atoms/modalAtom/modalAtom";

import { useAddStore, useEditStore } from "../api";
import { FromShopValues } from "../NewShop";

type Props = {
  handleSubmit: UseFormHandleSubmit<any>;
};

export const NewShopFooter = ({ handleSubmit }: Props): JSX.Element => {
  const { storeState, setStoreState } = useStoreState();
  const [, setInfoModal] = useAtom(setInfoModalAtom);

  const { mutate: addStore } = useAddStore();
  const { mutate: editStore } = useEditStore();

  const handleClick = (data: FromShopValues) => {
    if (
      !data.name ||
      !data.selectedPricelistItem?.value ||
      !data.selectedArticleListItem?.value
    ) {
      setInfoModal({ title: "Заполните все поля" });
      return;
    }
    if (storeState.activeItem) {
      editStore(
        {
          storesid: storeState.activeItem?.storesid,
          name: data.name,
          pricelistid: data.selectedPricelistItem?.value || "",
          articleid: data.selectedArticleListItem?.value || "",
          // usercalctype: +data.usercalctype,
          // usergetpercentbyplan: data.usergetpercentbyplan ? 1 : 0,
          // useroperationforpercent: data.useroperationforpercent ? 1 : 0,
          // dayopentimeafter: data.dayopentimeafter,
          // nightopentimeafter: data.nightopentimeafter,
        },
        { onSuccess: () => setStoreState({ activeItem: null }) }
      );
    } else {
      addStore(
        {
          name: data.name,
          pricelistid: data.selectedPricelistItem?.value || "",
          articleid: data.selectedArticleListItem?.value || "",
          // usercalctype: +data.usercalctype,
          // usergetpercentbyplan: data.usergetpercentbyplan ? 1 : 0,
          // useroperationforpercent: data.useroperationforpercent ? 1 : 0,
          // dayopentimeafter: data.dayopentimeafter,
          // nightopentimeafter: data.nightopentimeafter,
        },
        {
          onSuccess: () => setStoreState({ activeItem: null }),
        }
      );
    }
  };

  return (
    <div className="flex flex-row ">
      <Button
        variant={EButtonVariant.SECONDARY}
        onClick={handleSubmit(handleClick)}
        icon="galochka"
      >
        Сохранить
      </Button>
    </div>
  );
};
